var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["TextDecoder"]: () => __WEBPACK_EXTERNAL_MODULE_text_encoding_shim_6f8fb6d2__.TextDecoder });